__webpack_require__.p = "/simple-toolkit/";